import { MoreVerticalIcon } from "lucide-react";
import React, { useRef, useState, useEffect } from "react";


interface ActionNodeMenuProps {
  onDelete: () => void;
  onReset: () => void;
}

export const ActionNodeMenu: React.FC<ActionNodeMenuProps> = ({ onDelete, onReset }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      >
        <MoreVerticalIcon />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg z-50 min-w-[160px] overflow-hidden">
          <button
            onClick={() => { onDelete(); setOpen(false); }}
            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Delete Action
          </button>
          <button
            onClick={() => { onReset(); setOpen(false); }}
            className="w-full text-left px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
          >
            Reset Changes
          </button>
        </div>
      )}
    </div>
  );
};